var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import { H4, Body } from "@irati/ui/src/Typography";
import Flex from "@irati/ui/src/Flex";
var Paragraph = styled(Body)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 350px;\n"], ["\n  max-width: 350px;\n"])));
var SettingsTile = function (props) {
    var title = props.title, value = props.value, children = props.children;
    return (React.createElement(Flex, { direction: "column", width: "50%" },
        React.createElement(H4, { marginBottom: 1 },
            React.createElement(FormattedMessage, { id: title })),
        React.createElement(Paragraph, null,
            React.createElement(FormattedMessage, { id: value })),
        React.createElement(Flex, { marginTop: 3 }, children)));
};
export default SettingsTile;
var templateObject_1;
